"use client";

import * as React from "react";
import { cn } from "@/utils";

interface ChartBlockProps {
  title?: string;
  isSmall?: boolean;
  isLoading: boolean;
  className?: string;
  isRounded?: boolean;
  watermark?: boolean;
  slot?: React.ReactNode;
  children: React.ReactNode;
  border?: "all" | "bottom" | "none";
}

export const ChartBlock = React.forwardRef<HTMLDivElement, ChartBlockProps>(
  (
    {
      title,
      isLoading,
      children,
      isSmall,
      slot,
      watermark = true,
      className,
    },
    ref,
  ) => {
    return (
      <div ref={ref} className={cn("group relative select-none", className)}>
        {(title || slot) && (
          <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
            {title ? (
              <h2
                className={cn(
                  "font-semibold tracking-tight text-white",
                  isSmall ? "text-lg" : "text-xl md:text-2xl",
                )}
              >
                {title}
              </h2>
            ) : (
              <span />
            )}
            {slot}
          </div>
        )}

        <div
          className={cn("relative overflow-visible", {
            "before:absolute before:inset-0 before:z-10 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:rounded-2xl before:bg-gradient-to-r before:from-transparent before:via-white/[0.03] before:to-transparent":
              isLoading,
            "h-[24rem] md:h-[32rem] lg:h-[40rem]": !isSmall,
            "h-[20rem]": isSmall,
          })}
        >
          {watermark && !isLoading && (
            <div
              aria-hidden
              className="pointer-events-none absolute left-1/2 top-6 z-0 -translate-x-1/2 text-sm font-bold text-white/[0.035] md:text-2xl"
            >
              LookIntoHex.com
            </div>
          )}
          {!isLoading && children}
        </div>
      </div>
    );
  },
);

ChartBlock.displayName = "ChartBlock";

export default ChartBlock;
